import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 10,
    fontFamily: 'Helvetica',
    backgroundColor: '#fff',
  },
  heading: {
    fontSize: 14,
    marginBottom: 20,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: '#0d47a1',
    borderBottomWidth: 1,
    borderBottomColor: '#333',
    paddingBottom: 6,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableHeader: {
    backgroundColor: '#e3f2fd',
    borderBottomWidth: 1,
    borderBottomColor: '#333',
  },
  tableCell: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#333',
    padding: 5,
    fontSize: 9,
    textAlign: 'center', 
  },
  lastCell: {
    borderRightWidth: 0,
  },
  colOrderId: { width: '12%' },
  colApprovalDate: { width: '18%' },
  colTitle: { width: '32%' },
  colBatchId: { width: '20%' },
  colQuantity: { width: '18%' },
});

const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const [year, month, day] = dateStr.split('-');
  return `${day}-${month}-${year}`;
};

const chunkArray = (array, size) => {
  return Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
    array.slice(i * size, i * size + size)
  );
};

const MissingBatchPDF = ({ pdfItems }) => {
  const chunks = chunkArray(pdfItems, 16);

  return (
    <Document>
      {chunks.map((chunk, pageIndex) => (
        <Page key={pageIndex} style={styles.page}>
          <Text style={styles.heading}>MIS Report</Text>

          <View style={[styles.tableRow, styles.tableHeader]}>
          <Text style={[styles.tableCell, styles.colOrderId]}>SR.NO</Text>
            <Text style={[styles.tableCell, styles.colOrderId]}>Order ID</Text>
            <Text style={[styles.tableCell, styles.colApprovalDate]}>Order Date</Text>
            <Text style={[styles.tableCell, styles.colTitle]}>Title</Text>
            <Text style={[styles.tableCell, styles.colBatchId]}>Order Qty</Text>
            <Text style={[styles.tableCell, styles.colBatchId]}>Received Qty</Text>
            <Text style={[styles.tableCell, styles.colQuantity, styles.lastCell]}>Pending Qty</Text>
          </View>

          {chunk.map((item, index) => (
            <View key={index} style={styles.tableRow}>
              <Text style={[styles.tableCell, styles.colOrderId]}>{pageIndex * 16 + index + 1}</Text>
              <Text style={[styles.tableCell, styles.colOrderId]}>{item.orderid}</Text>
              <Text style={[styles.tableCell, styles.colApprovalDate]}>{formatDate(item.ApprovalDate)}</Text>
              <Text style={[styles.tableCell, styles.colTitle]}>{item.title}</Text>
              <Text style={[styles.tableCell, styles.colBatchId]}>{item.Oquantity}</Text>
              <Text style={[styles.tableCell, styles.colBatchId]}>{item.receivedQty}</Text>
              <Text style={[styles.tableCell, styles.colQuantity, styles.lastCell]}>
  {item.receivedQty && typeof item.quantity === "number"
    ? item.quantity < item.receivedQty * 0.05
      ? 0
      : item.quantity
    : ""}
</Text>

            </View>
          ))}
        </Page>
      ))}
    </Document>
  );
};

export default MissingBatchPDF;
